// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
`, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
export var colorGrey0 = `#567`;
export var colorGrey1 = `#5a6675`;
export var colorGrey2 = `#8fa0b3`;
export var colorGrey3 = `#d2d9e0`;
export var colorGrey4 = `#f4f5f7`;
export var colorGrey5 = `#fafafa`;
export var colorGrey6 = `#b1b1b1`;
export var colorGrey7 = `#e4e4e4`;
export var colorBlue1 = `#0056ad`;
export var colorBlue2 = `#83a4df`;
export var colorBlue3 = `#c8dbff`;
export var colorBlue4 = `#f2f7ff`;
export var colorBlue5 = `#c7dbfc`;
export var colorOrange1 = `#ff923d`;
export var colorOrange2 = `#ffc89e`;
export var colorOrange3 = `#f9ddc3`;
export var colorRed1 = `#ff5550`;
export var colorRed2 = `#ff9b87`;
export var colorRed3 = `#ff9b87`;
export var colorRed4 = `#ffebe6`;
export var colorRed5 = `#f7d0c8`;
export var colorGreen1 = `#def6cc`;
export var colorYellow1 = `#fffb00`;
export var colorYellow2 = `#fffd8f`;
export var colorYellow3 = `rgba(252,238,199,0.75)`;
export var darkGrey = `#28282e`;
export var white = `#fff`;
export default ___CSS_LOADER_EXPORT___;
